import React, { Component } from 'react'
import axios from 'axios'

import PlaceHolder from '../../../atoms/PlaceHolder'
import Font from '../../../atoms/Font'
import Valign from '../../../atoms/Valign'
import T from '../../../../SPRINTA/translate/T'
import { Row, Col } from '../../../atoms-v2/Grid'
import ActionBtnIcon from '../../../molecules/ActionBtnIcon'
import AspectRatio from '../../../atoms-v2/AspectRatio'
import FillModal from '../../../atoms-v2/FillModal'
import { LoadMap } from '../../../third-party/GoogleMap'


import style from './style.css'

export default class ListMaps extends Component {
    state = {
        status: 'loading',
        data: [],
        routeActive: 0,
        map: null,
        fullImage: null
    }

    componentWillMount() {
        this.mounted = true
        axios.get('event_maps/list_maps/'+this.props.token+'/0/1000')
        .then(resp => {
            if(!this.mounted) return

            let status = ''
            let data = []
            if(resp.total === 0) {
                status = 'no_content'
            } else {
                status = 'done'
                data = resp.result
            }

            let images = []
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                images.push(item.image_url)
            }

            this.setState({
                status,
                data,
                images
            }, () => {
                if(this.state.data.length > 0 && this.state.data[this.state.routeActive].type !== 'image')
                    this.activeRoute(this.state.routeActive)
            })
        })
    }

    componentWillUnmount() {
        this.mounted = false
    }

    activeRoute( item ) {
        let map = null
        if(this.state.data[item].type !== 'image')
            map = this.state.data[item].file_path

        this.setState({
            routeActive: item,
            map
        })
    }

    mapsLoaded = false
  
    setMap(map) {
        this.map.KmlLayer(map)
    }

    mapCreated( map ) {
        if(!map) return

        this.map = map

        this.map.handleLoad(() => {
            this.setMap(this.state.map)
            this.mapsLoaded = true
        })
    }

    componentWillUpdate(np, ns) {
        if(this.state.map !== ns.map && this.mapsLoaded)
            this.setMap(ns.map)
    }

    render() {
        if(this.state.status === 'loading')
        return (
            <div>
                <PlaceHolder type='retangle' style={{height:'250px'}} />
            </div>
        )
        
        if(this.state.status === 'no_content')
        return <span />

        if(this.state.status === 'done')
        return (
            <div style={{marginTop: '30px', marginBottom: '30px'}}>
                <Row>
                    <FillModal active={this.state.fullImage} handleClose={ () => {
                            this.setState({
                                fullImage: null
                            })
                        }} full>
                        <div style={{
                            width: '100%',
                            height: '100vh',
                            overflow: 'hidden',
                            textAlign: 'center'
                        }}>
                            <Valign>
                                <div style={{ width: '100%', textAlign: 'center' }}>
                                    <img
                                        alt='Full map'
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                        }}
                                        src={this.state.fullImage} />
                                </div>
                            </Valign>
                        </div>
                    </FillModal>
                    <Col>
                        <Font size='30' weight="100">{T.text('routes')}</Font>  
                        <div style={{marginBottom: '30px' }} />
                    </Col>
                    <Col>
                        {this.state.data.map( (map, key) => {
                            if(map.type !== 'image' && !this.renderMap)
                                this.renderMap = true

                            return (
                                <a key={map.id} onClick={() => { this.activeRoute(key) }} href={void(0)} className={`${style.itemList} ${key === this.state.routeActive ? style.active : ''} `}>
                                    {map.name}
                                </a>
                            )
                        })}
                    </Col>
                    <Col>
                        {this.state.data[this.state.routeActive].type === 'image' && (
                            <AspectRatio
                                ratio='2x1'
                                style={{
                                    borderRadius: '4px',
                                    backgroundColor: '#f9f9f9',
                                    backgroundSize: 'cover',
                                    backgroundImage: `url('${this.state.data[this.state.routeActive].file_path}')`,
                                }}>
                                <div style={{
                                    padding: '10px',
                                    float: 'right'
                                }}>
                                    <ActionBtnIcon
                                        style={{
                                                fontSize: '13px',
                                                }}
                                        icon='zoom_in'
                                        theme="rounded-orange"
                                        action={() => {
                                            this.setState({
                                                fullImage: this.state.data[this.state.routeActive].file_path
                                            })
                                        }}
                                    />
                                </div>
                            </AspectRatio>
                        )}
                        {this.renderMap && (
                            <div style={{
                                display: this.state.data[this.state.routeActive].type !== 'image' ? 'block' : 'none'                            
                            }}>
                                <AspectRatio
                                    ratio='2x1'
                                    style={{
                                        borderRadius: '4px',
                                        backgroundColor: '#f9f9f9',
                                        overflow: 'hidden',
                                    }}>
                                        <LoadMap height="100%" width="100%" ref={ref => this.mapCreated(ref)} />
                                </AspectRatio>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Event/ListMaps/index.js